import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const erisChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      26573178618.846352, -16387773.975522995, -646932.07207654312, 7415.2172267278038, -8323.9436000188198, 109.22588647206624, 94.356176757812506, 46.736784235636392,
      -5.0532103220621742, -24.071404139200848, -5.6366754531860348, 3.827763748168945,
    ]),
    new Float64Array([
      11089743983.489649, 78145522.070092112, -398183.81307948427, 49288.165058326718, 402.28576024373371, -605.58927001953123, -8.5563961346944168, -76.343680286407476,
      5.5200441042582193, 24.334548918406167, 5.8168741226196286, -5.2332119305928551,
    ]),
    new Float64Array([
      -4466385795.658534, 159655013.21384442, 131955.91982947986, 19756.159345785778, 474.82168498039243, -120.54526376724243, -97.035323619842529, -161.64877166748047,
      12.152445030212402, 60.183296918869019, 10.636487197875976, -11.842651319503783,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      26495240486.948833, -23002682.609952036, -1125675.1491638185, -50979.18652280172, 7457.8200316111243, 1846.0722495396931, 36.770537503560384, -60.298739306131999,
      -11.537845102945964, 7.1224896748860678, -7.8885211944580078, -1.5581720352172852,
    ]),
    new Float64Array([
      11398515179.666271, 76420330.522285372, -205498.59910589852, -46448.747175312041, -9240.9519263903294, 837.3274993260701, 256.25943126678465, 41.290767351786293,
      -4.9442735354105629, -20.11167548497518, 0.20696964263916015, 2.4292639096577964,
    ]),
    new Float64Array([
      -3824607858.109364, 161308885.21106189, 211290.80421071051, -19851.689908615746, -3965.6190046866736, 350.06836326122283, -70.993642989794409, -29.684226020177206,
      17.307865556081136, 10.979709219932555, 16.295523230234782, -2.4491120974222818,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      26385498828.438007, -31551692.566231027, -786579.91794166563, 58831.690633773804, -6570.4661165873213, -723.58887888590493, 271.79874407450359, -89.488177108764646,
      -10.071190071105956, 26.720972887674968, -3.7174545923868814, -7.1704570770263674,
    ]),
    new Float64Array([
      11696893993.257914, 72354878.281268507, -656979.51185032527, 26474.169750308989, 8108.9949076016746, -973.39710804621382, 24.117473125457764, -139.58083957036337,
      -9.2950264930725091, 65.137876001993817, -5.5610066095987953, -12.545801162719727,
    ]),
    new Float64Array([
      -3177826006.4173751, 161883352.32669735, -6663.5156020243958, 8461.061018021901, 3914.2054335196813, -461.44384493827818, -196.21833482583364, 10.317601124445597,
      16.965217590332031, 0.55234855810801187, 14.447954734166464, -0.20212852954864502,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      26248215513.296017, -37119172.454163931, -816530.0857147217, -57552.6014673233, -4441.0542226791385, 833.27548662821448, 238.84572798411051, 40.327154858907065,
      -10.563357480367024, -9.5532182693481449, -3.7468739827473958, 3.5013740539550779,
    ]),
    new Float64Array([
      11978981187.794336, 69114101.943272501, -174880.35905647278, 15500.23440694809, -8527.6060829480484, -719.55547850926712, 140.93656721115113, 1.0124205271402995,
      -6.7306448618570967, 4.9172896067301428, -5.7532210667928059, -2.3017561276753744,
    ]),
    new Float64Array([
      -2529182231.2288222, 162607729.71325088, 183919.22455454667, 6620.8301664829251, -3379.2897173563638, -498.34860298633572, -46.955839745203654, 136.91369257767994,
      7.5863854646682736, -49.914167904853819, 5.952906735738118, 9.1780833959579464,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      26083431893.191704, -45484567.958901912, -1037961.0357524236, 59709.662123743692, 6135.0659451802567, -2402.3542079925537, -96.882624435424802, 160.64480514526366,
      1.8799392064412435, -34.661446126302081, 1.0513060887654622, 9.5686294555664055,
    ]),
    new Float64Array([
      12250696568.101503, 66322391.407761, -633188.17198225658, -33422.179421710971, 11129.75807209015, 790.6819968859354, -333.74511470794675, -93.54140170415242,
      8.4322378158569329, 36.836797078450523, 0.43907365798950193, -5.6188555081685383,
    ]),
    new Float64Array([
      -1876669609.9909961, 163459144.1296961, -24066.552208646139, -17121.002134974799, 4596.8970995346708, 171.77381828625997, -100.66070140202839, 128.58197920322419,
      -0.8141665617624918, -48.57668211857478, -3.3690707127253212, 10.120265193780263,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      25888617241.92437, -51588863.077103294, -657882.7642333348, -24735.018598620096, -7056.2269019444784, 364.26779022216795, -141.83873526255289, -152.32988179524739,
      16.832046190897625, 60.952031326293941, 9.0603899002075199, -12.106802558898925,
    ]),
    new Float64Array([
      12506750041.376842, 62005361.888135433, -306099.26072057086, 45857.629583104448, -2709.3164357821147, -765.28345365524297, -124.79008512496948, 75.911478519439697,
      11.458867422739665, -30.083375485738117, 7.0170888582865398, 6.1526608784993488,
    ]),
    new Float64Array([
      -1223023350.3520539, 163471605.63012916, 90729.980366329357, 18741.68626284202, -1243.7548471252123, -427.51686393419902, 122.05213953256607, 126.35583085219065,
      -13.193722422917684, -49.248849916458127, -11.383148690064749, 9.717471198240915,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      25668140607.781704, -59157183.436104201, -1218622.1197214127, -8317.794043668111, 14010.200505256653, 678.36202265421548, -365.61582565307617, -75.120230738321936,
      8.2042796452840161, 12.369797325134277, 0.97605679829915359, -6.4861794153849281,
    ]),
    new Float64Array([
      12750950757.568474, 60006627.176202901, -417644.78545115789, -69042.164052677152, -1476.1083940823873, 2110.57563457489, -43.733511575063069, -88.67324136098226,
      11.070991929372152, 20.141849994659424, 11.759938462575276, -3.0206694602966309,
    ]),
    new Float64Array([
      -567235463.73561645, 164383714.75710139, 40491.452332921821, -30851.146277646225, -1272.7408113698164, 908.22621151208875, 200.45216836134591, -36.070847225189212,
      -17.336810342470805, 7.646703352530797, -12.759044015407563, -1.0806424220403035,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      25414809826.131744, -67026426.345303155, -697329.38609892526, 25350.79036095937, -8290.7115998586014, 121.02784182230631, 152.94014110565186, -69.772685750325522,
      -7.2204060236612957, 17.134142684936524, -7.0192643483479813, -4.2915076573689781,
    ]),
    new Float64Array([
      12981336723.356247, 55042515.78734716, -588547.75709171291, 44925.116387875874, 2582.5908576011657, -1055.4920445124308, -57.679856904347737, 169.74574839274089,
      10.792337862650554, -67.27277625401814, 11.89112564722697, 11.661181831359864,
    ]),
    new Float64Array([
      89510168.706331447, 163901882.19238561, -62089.176107860105, 17309.54097561141, 1139.2669243082405, -340.16924131462969, 111.25184948345026, -34.850466588139533,
      -9.8779100775718689, 13.189630504449209, -7.1790148854255671, -2.919216307500998,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      25134671397.206478, -73344477.814924553, -1041572.6524009069, -58289.184306780495, 3240.5544776916504, 1902.6250716527302, 95.510578664143878, -139.30572751363118,
      -7.0246681213378901, 41.890966924031574, -2.177337392171224, -7.9002698898315424,
    ]),
    new Float64Array([
      13195028424.002544, 52085581.697937615, -276059.93900794984, -26283.592572752634, -10040.554531606038, 101.87332728703817, 127.36710977554321, -21.443074226379395,
      7.1586056709289547, 18.085368760426839, 8.3505852063496899, -1.5735735257466634,
    ]),
    new Float64Array([
      745298603.40406919, 164105967.5846529, 62957.412428747615, -11187.272733761867, -4442.124469722311, 157.35234591762224, 68.858010295033452, -161.83151232302188,
      1.7573487887779871, 67.038111041982972, 2.2491604000329972, -12.077960261702538,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      24823686805.511971, -81977848.916298926, -856385.03623765311, 65945.510654195154, -4171.4312580108644, -1452.8380902608235, 319.9518522262573, 28.176712926228841,
      -16.197142028808592, -9.9032161076863598, -5.4130818684895834, 0.031123669942220052,
    ]),
    new Float64Array([
      13395318768.920448, 47606438.689371966, -764498.81480719242, 11943.294659328461, 10440.81207450231, -995.32585407892861, -180.49319972991944, 159.7933050473531,
      2.6993062655131022, -51.35351012547811, 0.97282946904500323, 9.1471729914347328,
    ]),
    new Float64Array([
      1401072585.1427896, 163566475.64353803, -169787.57751660745, 2096.8387095073858, 4703.2448760867119, -205.74544191559156, -198.45199980735779, -84.649180712302524,
      13.629931493600209, 35.938910859823224, 10.536010481913884, -7.5418033003807068,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      24484383387.913143, -87597358.297116533, -764656.70495249424, -51681.979003842673, -5965.2488852183023, 419.39473285675047, 184.20267613728842, 67.940901184082037,
      -7.8134059270222984, -15.688023440043132, -4.4446889877319338, 5.1867516835530596,
    ]),
    new Float64Array([
      13576374433.005728, 43355128.8356575, -275158.20576995215, 28320.756677945454, -6803.3702358245846, -742.83188209533694, 86.309854634602857, -51.893963019053139,
      -6.9096744855244951, 25.275561777750649, -7.7241805076599119, -4.6856787045796713,
    ]),
    new Float64Array([
      2053670235.0490847, 162900257.95569414, 18547.517650032045, 11761.596207439899, -2452.2168314496676, -235.26807568073272, -170.00634066661198, -80.790033415953317,
      18.117021067937216, 31.81176599661509, 13.625784973303476, -6.5467272400856018,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      24156918269.335285, -76097052.445332974, -776511.27195885975, 13088.300376319885, 5971.234249051412, -251.76654218037922, -135.60208606719971, 0.47768650054931638,
      5.4027836481730143, -4.0732933680216474, -2.6793680826822914, 1.5922475814819337,
    ]),
    new Float64Array([
      13728652541.836557, 32686273.01703418, -387732.03089224495, -34370.32392250697, 2057.8929338137309, 632.49690694808965, -69.561884021759028, -5.2332921663920082,
      12.115367603302001, 4.2658051490783695, -1.3833042780558269, -1.6547003110249836,
    ]),
    new Float64Array([
      2640179093.4943376, 130260477.93906723, -82873.677642615628, -16201.865444564819, 898.64279374281568, 426.99342446327211, -111.4369137207667, -11.854016399383545,
      29.441266949971517, -7.233795166015625, -3.6589935223261514, 2.8228774785995485,
    ])
  ),
];
